import { render, staticRenderFns } from "./shipped-order.vue?vue&type=template&id=33c2306a&"
import script from "./shipped-order.vue?vue&type=script&lang=js&"
export * from "./shipped-order.vue?vue&type=script&lang=js&"
import style0 from "./shipped-order.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports